<template>
  <div class="container sensory-calibration-detail">
    <el-row style="margin: 20px 0 20px 0">
      <el-button v-if="action=='SP_EDIT' || action=='CQS_EDIT'" type="primary" v-acl="CalibrationSave" @click="save()">{{$t("visitPlan.draftSave")}}</el-button>
      <el-button v-if="action=='CQS_EDIT'" type="primary" v-acl="CalibrationCalibration" @click="calibrate()">{{$t("sensory.calibration.calibration")}}</el-button>
      <el-button v-if="action=='SP_EDIT' || action=='CQS_EDIT'" type="primary" v-acl="CalibrationSave" @click="submit()">{{$t("common.submit")}}</el-button>
      <el-button type="primary" @click="$router.push({name:'sensoryCalibration'})">{{$t("common.close")}}</el-button>
      <template v-if="(action=='SP_EDIT' || action=='CQS_EDIT')||(action=='SP_EDIT' || action=='CQS_EDIT')" v-acl="CalibrationSave">
        <br />
        <label style="font-size:12px;color:#F56C6C;">{{$t('visitPlan.operationTips')}}</label>
      </template>
    </el-row>
    <el-form :model="calibration" ref="calibration" label-width="150px" :rules="calibrationRules">
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item :label="$t('sensory.report.serialNo')">
            <el-input disabled class="handle-input" v-model="calibration.serialNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="(action=='SP_EDIT'||action=='SP_SUBMIT')?16:8">
          <el-form-item :label="$t('sensory.report.name')" prop="fiveBitCodeName">
            <PickupFiveBitCode :disabled="disabled" @pickup="changeFiveBitCode" :fiveBitCode="{fiveBitCode:calibration.fiveBitCode,fiveBitCodeName:calibration.fiveBitCodeName}" v-model="calibration.fiveBitCodeName" :title="$t('sensory.report.name')"></PickupFiveBitCode>
          </el-form-item>
        </el-col>
        <el-col v-if="(action=='CQS_EDIT'||action=='CQS_SUBMIT')" :span="8">
          <el-form-item :label="$t('sensory.report.rater')" prop="rater">
            <el-autocomplete :title="calibration.rater" :disabled="action!='CQS_EDIT'" class="inline-input" clearable @select="selectQaLab" v-model="calibration.rater" :fetch-suggestions="raterSuggest" placeholder="请输入内容">
              <el-button slot="append" icon="el-icon-search" @click="searchRater()"></el-button>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item :label="$t('sensory.report.rateDate')" prop="rateDate">
            <el-date-picker :disabled="disabled" value-format="yyyy-MM-dd" type="date" v-model="calibration.rateDate"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('sensory.report.rateType')" prop="rateType">
            <ic-select :disabled="true" table="TT_SENSORY" field="RATE_TYPE" v-model="calibration.rateType" clearable></ic-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('sensory.report.status')">
            <!--                        <ic-select :disabled="true" table="TT_SENSORY_CALIBRATION" field="STATUS" v-model="calibration.status"></ic-select>-->
            <el-input v-model="calibration.statusI18n" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="16">
          <el-form-item :label="$t('nav.plant')" prop="plantNames">
            <el-input :value="plants" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('sensory.calibration.sourceSerialNo')" prop="sourceSerialNo">
            <el-input ref="pickUpSourceInput" @focus="prePickUpSource()" v-model="calibration.sourceSerialNo" :disabled="action!='CQS_EDIT'"></el-input>
            <el-dialog :visible="showPickupSourceDialg" width="80%" @close="showPickupSourceDialg = false">
              <sensory-report-list @pickUp="pickUpSource" :five-bit-code-name="calibration.fiveBitCodeName" :fiveBitCode="calibration.fiveBitCode" action="pickUp"></sensory-report-list>
              <!--                            <sensory-calibration-list @pickUp="pickUpSource" action="pickUp"></sensory-calibration-list>-->
            </el-dialog>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('common.remarks')" prop="remarks">
            <el-input :disabled="disabled" class="handle-input" v-model="calibration.remark" maxlength="300"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="calibration.status=='INACTIVE'" :span="24">
          <el-form-item label="作废原因">
            <el-input :disabled="true" class="handle-input" v-model="calibration.inactiveReason" maxlength="300"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-if="(action=='CQS_EDIT'||action=='CQS_SUBMIT')">
          <el-form-item class="cqs-email-input" :label="$t('sensory.calibration.cqsEmail')" prop="cqsEmail">
            <el-input :disabled="action!='CQS_EDIT'" class="handle-input" v-model="calibration.cqsEmail"></el-input>
          </el-form-item>
          <el-button type="primary" v-acl="CalibrationSendMail" icon="el-icon-message" circle @click="preSendMail"></el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="currentTab">
      <!-- 供应商自评 -->
      <el-tab-pane :label="$t('sensory.calibration.supSelfEvaluation')" name="supSelfEvaluation">
        <SupplierSelfEvaluation ref="supplierSelfEvaluation" @change-plants="changePlants" :plantBatchSpList.sync="calibration.plantBatchSpList" :tt-sensory-calibration-id="calibration.ttSensoryCalibrationId" :five-bit-code="calibration.fiveBitCode" :template-list="calibration.templateList" :action="action" :files.sync="calibration.docList" :fiveBitCodeObj='fiveBitCodeObj'></SupplierSelfEvaluation>
      </el-tab-pane>
      <el-tab-pane v-if="(emplFlag == 'SUP'&&calibration.status=='CQS_SUBMIT') || (emplFlag == 'MCD')" :label="$t('sensory.calibration.CQSEvaluation')" name="CQSEvaluation">
        <CQSEvaluation ref="CQSEvaluation" :plant-batch-cqs-list="calibration.plantBatchCqsList" :action="action" :template-list="calibration.templateList"></CQSEvaluation>
      </el-tab-pane>
      <el-tab-pane v-if="(emplFlag == 'SUP'&&calibration.status=='CQS_SUBMIT') || (emplFlag == 'MCD')" :label="$t('sensory.calibration.calibrationAnalysis')" name="calibrationAnalysis">
        <AnalysisDetails :analysisDetails="calibration.analysisDetails"></AnalysisDetails>
      </el-tab-pane>
      <el-tab-pane v-if="(emplFlag == 'SUP'&&calibration.status=='CQS_SUBMIT') || (emplFlag == 'MCD')" :label="$t('sensory.calibration.userCalibrationInfo')" name="userCalibrationInfo">
        <PersonnelCalibration :personnel-calibration="calibration.personnelCalibration"></PersonnelCalibration>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="showRaterDialog" append-to-body width="80%" title="评估人选择器">
      <pickupUser @input="selectRater" :multi="true"></pickupUser>
    </el-dialog>
    <el-dialog :visible="showSendMailDialog" :title="$t('sensory.calibration.sendEmail')" @close="showSendMailDialog = false">
      <el-container>
        <el-form style="width: 100%" label-width="180px" ref="email" :rules="sendMailRules" label-position="right" label-suffix=":">
          <el-row style="margin-bottom: 20px;">
            <el-button type="primary" @click="saveMail('save')">{{$t("common.save")}}</el-button>
            <el-button type="primary" @click="saveMail('submit')">{{$t("common.send")}}</el-button>
          </el-row>
          <el-card>
            <el-form-item prop="to" :label="$t('sensory.calibration.emailReceivers')">
              <el-input v-model="email.to"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sensory.calibration.emailTitle')">
              <el-input v-model="email.title"></el-input>
            </el-form-item>
            <el-form-item :label="$t('sensory.calibration.emailContent')">
              <el-input type="textarea" rows="5" v-model="email.content"></el-input>
            </el-form-item>
          </el-card>
          <FileUpload :biz-id="calibration.ttSensoryCalibrationId" :value="calibration.mailDocList" rec-type="SENSORY_CALIBRATION" seq="MAIL" style="margin-top:20px"></FileUpload>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import fiveBitCode from "@/api/base-data/fiveBitCode";
import calibrationApi from "@/api/sensory/calibration";
import IcSelect from "@/components/common/icSelect";
import PickupFiveBitCode from "@/components/page/main-data/fiveBitCode/pickupFiveBitCode";
import commonFun from "@/utils/commonFun";
import FileUpload from "@/components/common/fileUpload";
import { Message } from "element-ui";
import { getTemplateByFiveBitCode } from "@/api/sensory/calibration";
import SupplierSelfEvaluation from "@/components/page/sensory/sensory-calibration/supplierSelfEvaluation";
import CQSEvaluation from "@/components/page/sensory/sensory-calibration/CQSEvaluation";
import FileList from "@/components/common/fileList";
import AnalysisDetails from "@/components/page/sensory/sensory-calibration/analysisDetails";
import PersonnelCalibration from "@/components/page/sensory/sensory-calibration/personnelCalibration";
import SensoryCalibrationList from "@/components/page/sensory/sensory-calibration/sensoryCalibrationList";
import commonMethods from "@/utils/commonMethods";
import pickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import template from "@/api/sensory/template";
import SensoryReportList from "@/components/page/sensory/sensory-report/sensoryReportList";

let unsame = (rule, value, callback) => {
  let count = 0;
  this.tableHeadData.forEach(plant => {
    plant.batches.forEach(batch => {
      if (batch.batchNo == value) {
        count++;
      }
    })
  })
  if (count > 1) {
    return callback(new Error('Batch No. cannnott be the same!'));
  } else {
    return callback();
  }
};

export default {
  extends: commonMethods,
  name: "sensoryCalibrationDetail",
  components: { SensoryReportList, pickupUser, SensoryCalibrationList, PersonnelCalibration, AnalysisDetails, FileList, CQSEvaluation, SupplierSelfEvaluation, FileUpload, PickupFiveBitCode, IcSelect },
  data() {
    return {
      emplFlag: "",
      fiveBitCodeChanged: false,
      calibration: {
        plantBatchSpList: [],
        plantBatchCqsList: [],
        docList: [],
        mailDocList: [],
        templateList: [],
        analysisDetails: [],
        personnelCalibration: [],
        fiveBitCodeName: "",
        rateDate: "",
        rateType: 'Select',
        rater: null,
      },
      fiveBitCodeObj: {},
      calibrationRules: {
        fiveBitCodeName: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
        rateDate: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
        rater: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
        rateType: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
      },
      sendMailRules: {//给个错误的事件，只为显示必填写标识
        to: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["changedd"] },
      },
      currentTab: 'supSelfEvaluation',
      action: null,
      showSendMailDialog: false,
      showPickupSourceDialg: false,
      showRaterDialog: false,
      email: {
        to: "",
        title: "",
        content: "",
        attachments: []
      },
      plantUsers: [],
      isMounted: false
    }
  },
  created() {
    if (this.$route.name == 'sensoryCalibrationDetail') {
      this.getData();
    } else {
      this.getData();
      this.action = 'SP_EDIT';
    }
    if (this.calibration != null && commonFun.isNotEmpty(this.calibration.fiveBitCode)) {
      getTemplateByFiveBitCode(this.calibration.fiveBitCode)
    }
    this.emplFlag = localStorage.getItem('ms_emplFlag');
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    plants() {
      if (!this.isMounted)
        return;
      let supplierSelfEvaluation = this.$refs["supplierSelfEvaluation"];
      if (null != supplierSelfEvaluation) {
        let supplierData = supplierSelfEvaluation.tableHeadData;
        let s = supplierData.map(plant => plant.plantName).join(";");
        return s;
      }
      return [];
    },
    disabled() {
      return !((this.action == 'SP_EDIT' && (this.calibration.allPlantFlag || this.calibration.ttSensoryCalibrationId == null)));
    }
  },
  methods: {
    prePickUpSource() {
      this.$refs['pickUpSourceInput'].blur();
      this.confirm(this.$t("sensory.calibration.pickUpSourceWarn"), {
        showCancelButton: false
      }).then(() => {
        this.showPickupSourceDialg = true;
      });
    },
    pickUpSource(data) {
      let that = this;
      this.calibration.sourceSerialNo = data.reportNo;
      calibrationApi.getSourceScore(this.calibration.ttSensoryCalibrationId, data.ttSensoryReportId).then(resp => {
        that.$set(that.calibration, "plantBatchCqsList", resp.plantBatchCqsList)
        that.showPickupSourceDialg = false;

        that.$nextTick(() => {
          this.$refs["CQSEvaluation"].$refs["scoreTable"].doLayout();
        })
      })
    },
    getData() {
      let calibrationId = this.$route.params.id;
      if (commonFun.isEmpty(calibrationId)) {
        calibrationId = -9999;
      }
      let that = this;
      calibrationApi.getDetail(calibrationId).then(resp => {
        console.log(resp, "resp")
        let data = resp.data;
        let calibration = data.headInfo;
        that.plantUsers = data.plantUsers == null ? [] : data.plantUsers;
        calibration.plantBatchSpList = data.plantBatchSpList;
        calibration.plantBatchCqsList = data.plantBatchCqsList;
        calibration.docList = commonFun.isEmpty(data.docList) ? [] : data.docList;
        calibration.mailDocList = data.mailDocList;
        calibration.analysisDetails = data.analysisDetails;
        calibration.personnelCalibration = data.personnelCalibration;
        calibration.templateList = [];
        that.calibration = calibration;
        that.initTemplateData(data.templateList);
        that.action = data.action;
        if (calibration.fiveBitCodeName == null) {//解决一进入页面就报不能为空
          calibration.fiveBitCodeName = ''
        }
        if (calibration.rateDate == null) {//解决一进入页面就报不能为空
          calibration.rateDate = ''
        }
        if (resp.data.headInfo.fiveBitCode) {
          fiveBitCode.getDetail(resp.data.headInfo.fiveBitCode).then(res => {
            that.fiveBitCodeObj = {
              categoryLevel1Code: res.data.categoryLevel1Code,
              categoryLevel2Code: res.data.categoryLevel2Code,
              categoryLevel3Code: res.data.categoryLevel3Code,
              fiveBitCode: res.data.fiveBitCode,
              fiveBitCodeName: res.data.fiveBitCodeName,
            }
          })
        }
      });
    },
    initTemplateData(templateList) {
      let that = this;
      let templateDetailList = [];
      let rowIndex = 0;
      if (commonFun.isEmpty(templateList)) {
        return;
      }
      templateList.forEach((templateListInfo, index) => {
        templateListInfo.itemList.forEach(item => {
          if (commonFun.isNotEmpty(item.detail) && item.isComments == 'N') {
            let split = item.detail.split('`');
            let start = 0;
            let end = 0;
            for (let detailIndex in split) {
              if (commonFun.isNotEmpty(split[detailIndex])) {
                if (start == 0) {
                  start = detailIndex - (-1);
                }
                end = detailIndex - (-1);
              }
            }
            item.start = start;
            item.end = end;
          }
        })
        if (templateListInfo.type == 'APPEARANCE') { //APPEARANCE
          templateDetailList.push({
            title: 'Appearance:',
            detailType: "TITLE",
            detail: templateListInfo.desc,
          });
          templateListInfo.itemList.forEach(detail => {
            detail.index = rowIndex++;
            detail.detailType = "APPEARANCE";
            templateDetailList.push(detail);
          });
          templateDetailList.push({ title: that.$t("sensory.report.overallAppearanceScore"), detailType: "SCORE", scoreField: "AppearanceScore" });
        } else if (templateListInfo.type == 'TEXTURE') {
          templateDetailList.push({ title: 'Texture/ Mouthfeel', detailType: "TITLE", detail: templateListInfo.desc })
          templateListInfo.itemList.forEach(detail => {
            detail.index = rowIndex++;
            detail.detailType = "TEXTURE";
            templateDetailList.push(detail);
          });
          templateDetailList.push({ title: that.$t("sensory.report.overallTextureScore"), detailType: "SCORE", scoreField: "TextureScore" });
        } else if (templateListInfo.type == 'FLAVOR') {
          templateDetailList.push({ title: 'Aroma/ Flavor:', detailType: "TITLE", detail: templateListInfo.desc })
          templateListInfo.itemList.forEach(detail => {
            detail.index = rowIndex++;
            detail.detailType = "FLAVOR";
            templateDetailList.push(detail);
          });
          templateDetailList.push({ title: that.$t("sensory.report.overallFlavorScore"), detailType: "SCORE", scoreField: "FlavorScore" });
        }
      });
      templateDetailList.push({ title: that.$t("sensory.report.productQualityScore"), detailType: "SCORE", scoreField: "QualityScore" });
      that.$set(that.calibration, 'templateList', templateDetailList);
    },
    save() {
      let calibration = this.prepareSaveData();
      let that = this;
      calibrationApi.save(calibration).then(resp => {
        that.$message({
          message: this.$t("common.saveSuccess"),
          type: "success"
        });
        if (this.$route.name == 'newSensoryCalibration') {
          that.$router.replace({ path: `/sensoryCalibration-edit/${resp.headInfo.ttSensoryCalibrationId}` });
        }
        that.getData();
      })
    },
    submit() {
      let that = this;
      this.calibrationRules = {
        fiveBitCodeName: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
        rateDate: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
        rater: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
        rateType: { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] },
      };
      return this.$nextTick(() => {
        this.$refs.calibration.validate((valid) => {
          if (valid) {
            let calibration = that.prepareSaveData();

            let detailValid = null;
            if (that.action == 'SP_EDIT') {
              detailValid = that.$refs.supplierSelfEvaluation.validate();
            } else {
              detailValid = that.$refs.CQSEvaluation.validate();
            }
            detailValid.then((valid) => {
              if (valid) {
                let promise = this.confirm(that.$t("sensory.calibration.sureToSubmit"), this.$t('common.tips'), null, null, {
                  confirmButtonText: this.$t('common.confirm'),
                  cancelButtonText: this.$t('common.cancel'),
                  cancelButtonClass: 'el-button--primary',
                  confirmButtonClass: 'el-button--primary',
                  type: 'warning'
                });
                promise.then(() => {
                  calibration.method = "submit";
                  // that.$message({
                  //     message: this.$t("common.submitSuccess"),
                  //     type: "success"
                  // });
                  calibrationApi.save(calibration).then(resp => {
                    that.$message({
                      message: this.$t("common.submitSuccess"),
                      type: "success"
                    });
                    if (this.$route.name == 'newSensoryCalibration') {
                      that.$router.replace({ path: `/sensoryCalibration-edit/${resp.headInfo.ttSensoryCalibrationId}` });
                    }
                    that.getData();
                  })
                }).catch()
              }
            });
          }
        })
      })
    },
    prepareSaveData() {
      let supplierSelfEvaluation = this.$refs["supplierSelfEvaluation"];
      let supplierData = supplierSelfEvaluation.tableHeadData;
      let templateList = this.calibration.templateList;
      let supplierList = [];
      let cqsDataList = [];
      let plantIdList = [];
      supplierData.forEach(plant => {
        plantIdList.push(plant.tmPlantId);
        plant.batches.forEach(batch => {
          batch.users.forEach(user => {
            let batchInfo = {
              ttSensoryClbPlantBatchId: user.ttSensoryClbPlantBatchId,
              tmPlantId: plant.tmPlantId,
              type: 'SP',
              batchNo: batch.batchNo,
              userName: user.userName,
              appearanceScore: commonFun.trim(supplierSelfEvaluation.countScore("AppearanceScore", user), "%"),
              textureScore: commonFun.trim(supplierSelfEvaluation.countScore("TextureScore", user), "%"),
              flavorScore: commonFun.trim(supplierSelfEvaluation.countScore("FlavorScore", user), "%"),
              totalScore: commonFun.trim(supplierSelfEvaluation.countScore("QualityScore", user), "%"),
            }
            let clbDetailList = [];
            templateList.forEach(template => {
              if (template.ttTemplateDetailId) {
                let clbDetail = {
                  templateDetailId: template.ttTemplateDetailId,
                  score: user.scores[template.ttTemplateDetailId]
                };
                clbDetailList.push(clbDetail);
              }
            })
            batchInfo.clbDetailList = clbDetailList;
            supplierList.push(batchInfo);
          })
        })
      });

      if (this.action == 'CQS_EDIT') {
        let CQSEvaluation = this.$refs["CQSEvaluation"];
        let cqsData = CQSEvaluation.tableHeadData;
        cqsData.forEach(plant => {
          plant.batches.forEach(batch => {
            let batchInfo = {
              ttSensoryClbPlantBatchId: batch.ttSensoryClbPlantBatchId,
              tmPlantId: plant.tmPlantId,
              type: 'CQS',
              batchNo: batch.batchNo,
              appearanceScore: commonFun.trim(CQSEvaluation.countScore("AppearanceScore", batch), "%"),
              textureScore: commonFun.trim(CQSEvaluation.countScore("TextureScore", batch), "%"),
              flavorScore: commonFun.trim(CQSEvaluation.countScore("FlavorScore", batch), "%"),
              totalScore: commonFun.trim(CQSEvaluation.countScore("QualityScore", batch), "%"),
              tmPlantId: plant.tmPlantId
            }
            batchInfo.clbDetailList = Object.values(batch.scores);
            cqsDataList.push(batchInfo);
          })
        })
      }
      let files = supplierSelfEvaluation.files;
      let calibration = this.calibration;
      calibration.plantIdList = plantIdList;
      let data = {
        fiveBitCodeChanged: this.fiveBitCodeChanged,
        method: null,
        headInfo: calibration,
        plantBatchSpList: supplierList,
        plantBatchCqsList: cqsDataList,
        // templateList:
        docList: files,
        analysisDetails: null,
        personnelCalibration: null,
      };
      return data;
    },
    changeFiveBitCode(fiveBitCode) {
      console.log("🚀 ~ file: sensoryCalibrationDetail.vue:506 ~ changeFiveBitCode ~ fiveBitCode:", fiveBitCode)
      let that = this;
      this.fiveBitCodeObj = fiveBitCode;
      this.calibration.fiveBitCode = fiveBitCode.fiveBitCode;
      this.calibration.fiveBitCodeName = fiveBitCode.fiveBitCodeName;
      this.fiveBitCodeChanged = true;
      getTemplateByFiveBitCode(fiveBitCode.ttSensoryTemplateId).then(res => {
        if (res.meta.code != 200) {
          Message.error(that.$t("sensory.report.pleaseMaintainTemplateFirst"));
          that.calibration.templateList = [];
          that.calibration.plantBatchSpList = [];
          that.calibration.ttSensoryTemplateId = null;
        } else {
          let template = res.data;
          that.calibration.ttSensoryTemplateId = template.id;
          that.initTemplateData(template.templateList);
        }
      })
    },
    changePlants(plants) {
      this.calibration.plantNames = plants;
    },
    calibrate() {
      let that = this;
      that.$refs.CQSEvaluation.validate().then((valid) => {
        if (valid) {
          calibrationApi.calibration(this.calibration.ttSensoryCalibrationId).then(res => {
            that.$set(that.calibration, "analysisDetails", res.analysisDetails);
            that.$set(that.calibration, "personnelCalibration", res.personnelCalibration);
          });
        }
      })
    },
    selectQaLab(item) {
      this.$set(this.calibration, "rater", item.value);
    },
    searchRater() {
      this.showRaterDialog = true;
    },
    selectRater(users) {
      let raters = null;
      if (commonFun.isNotEmpty(users)) {
        raters = users.map(user => user.name).join(',');
      }
      this.$set(this.calibration, "rater", raters);
      this.showRaterDialog = false;
    },
    raterSuggest(queryString, cb) {
      let restaurants = [{ value: 'QA LAB' }];
      let res = queryString ? restaurants.filter(this.strFilter(queryString)) : restaurants;
      cb(res);
    },
    strFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    preSendMail() {
      let _this = this;
      let mailTo = '';
      if (_this.email.to == '') {
        if (_this.calibration.mailTos == null || _this.calibration.mailTos == '') {
          mailTo = _this.calibration.cqsEmail;
        } else {
          mailTo = _this.calibration.mailTos;
        }
        let mailData = {
          'to': mailTo,
          'title': _this.calibration.mailTitle,
          'content': _this.calibration.mailContent
        }
        _this.email = mailData;
      } else {
        //每次打开都要获取主界面的邮箱
        if (!(_this.calibration.cqsEmail == null || _this.calibration.cqsEmail == '')) {
          //[,，;；],建议使用英文逗号分隔
          let splitStr = ',';
          let arr1 = _this.calibration.cqsEmail.split(',');
          let arr2 = _this.calibration.cqsEmail.split('，');
          let arr3 = _this.calibration.cqsEmail.split('；');
          let arr4 = _this.calibration.cqsEmail.split(';');
          let newArr = arr1;
          if (arr2.length > 1) {
            newArr = arr2;
            splitStr = '，';
          } else if (arr3.length > 1) {
            newArr = arr3;
            splitStr = '；';
          } else if (arr4.length > 1) {
            newArr = arr4;
            splitStr = ';';
          }
          let newArrTo = [];
          if (!(_this.email.to == null || _this.email.to == '')) {
            let arrTo1 = _this.email.to.split(',');
            let arrTo2 = _this.email.to.split('，');
            let arrTo3 = _this.email.to.split('；');
            let arrTo4 = _this.email.to.split(';');
            newArrTo = arrTo4;
            if (arrTo1.length > 1) {
              newArrTo = arrTo1;
            } else if (arrTo2.length > 1) {
              newArrTo = arrTo2;
            } else if (arrTo3.length > 1) {
              newArrTo = arrTo3;
            }
          }

          let appendMail = [];
          newArr.forEach(item => {
            if (newArrTo.indexOf(item) == -1) {
              appendMail.push(item);
            }
          })

          if (appendMail.length > 0) {//需要追加E-MAIL
            if (newArrTo.length > 0) {//弹出页面有自己的E-MAIL
              _this.email.to += (splitStr + appendMail.join(splitStr));
            } else {//弹出页面还没有E-MAIL
              _this.email.to = appendMail.join(splitStr);
            }
          }
        }
      }
      _this.showSendMailDialog = true;
    },
    saveMail(isSend) {
      let email = {
        ttSensoryCalibrationId: this.calibration.ttSensoryCalibrationId,
        mailTos: this.email.to,
        mailTitle: this.email.title,
        mailContent: this.email.content,
        method: isSend
      };
      let that = this;
      calibrationApi.sendMail(email).then(res => {
        if (res.meta.success) {
          Message.success(that.$t("common.operateSuccess"));
        } else {
          Message.error(res.meta.msg);
        }
      })
    }
  },
}
</script>
<style  lang="scss">
.sensory-calibration-detail {
  .cqs-email-input {
    width: calc(100% - 80px);
    display: inline-block;
    margin-right: 20px;
  }

  .template-detail {
    padding: 0 !important;
  }

  // .el-table .cell {
  //     padding: 0 !important;
  // }

  /*.template-detail-cell {*/
  /*    width: 80px;*/
  /*    display: inline-block;*/
  /*    text-align: center !important;*/
  /*}*/

  /*.template-detail-cell.row1:not(:first-child){border-left:1px solid #EBEEF5; }*/
  .template-detail-cell.row2 {
    border-top: 1px solid #ebeef5;
  }

  .template-detail-cell.row2:not(:first-child) {
    border-left: 1px solid #ebeef5;
  }

  tr.title td {
    font-weight: bold;
    font-style: oblique;
    background-color: #fdfdfb !important;
  }

  .plant-select {
    width: calc(100% - 30px);
    vertical-align: middle;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
